import { Route, Routes } from 'react-router-dom';
import GenericSharingPage from './GenericSharingPage';
import { ENTITY_TYPE } from './utils';

export const ENTITY_TYPE_EDIT_PATHS: Record<string, string> = Object.freeze({
    [ENTITY_TYPE.User]: 'share-user-edit',
    [ENTITY_TYPE.MeasuringPoint]: 'share-measuring-point-edit/:id/',
    [ENTITY_TYPE.Project]: 'share-project-edit/:id/',
});

export default function SharingRoutes(): JSX.Element {
    return (
        <Routes>
            {Object.entries(ENTITY_TYPE_EDIT_PATHS).map(([entityType, path]) => (
                <Route
                    key={path}
                    path={path}
                    element={<GenericSharingPage entityType={entityType} />}
                ></Route>
            ))}
        </Routes>
    );
}
